var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React from 'react';
import cx from 'classnames';
// dls
import { TextField } from '@swiggy-private/dls-web-core/dist/components/TextField';
// styles
import styles from './DlsTextField.module.scss';
// TODO:: currently adding z-index and position relative for showing errors message for dls component
// not showing error message without specifying z-index and position
const DlsTextField = (_a) => {
    var { wrapperClassName } = _a, props = __rest(_a, ["wrapperClassName"]);
    return (React.createElement("div", { className: cx(styles.wrapper, wrapperClassName) },
        React.createElement(TextField, Object.assign({}, props))));
};
export default DlsTextField;
